import { render, staticRenderFns } from "./MobileMenuList.vue?vue&type=template&id=90a37e52&scoped=true&"
import script from "./MobileMenuList.vue?vue&type=script&lang=js&"
export * from "./MobileMenuList.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuList.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./MobileMenuList.vue?vue&type=style&index=1&id=90a37e52&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a37e52",
  null
  
)

export default component.exports